module.exports = __webpack_public_path__ + "img/electric.29e25ff8.png";